export enum EFilters {
	SOURCE = 'source_uuid',
	BRAND = 'brand_uuid',
	OFFER = 'offer_uuid',
	SEARCH = 'name',
	STATUS = 'status',
	DATE_AFTER = 'date_after',
	DATE_BEFORE = 'date_before',
	CREATED_AFTER = 'created_after',
	CREATED_BEFORE = 'created_before',
	CREATED_AT_AFTER = 'created_at_after',
	CREATED_AT_BEFORE = 'created_at_before',
	FIRST_CLICK_TIME_AFTER = 'first_click_time_after',
	FIRST_CLICK_TIME_BEFORE = 'first_click_time_before',
	LAST_CLICK_TIME_AFTER = 'last_click_time_after',
	LAST_CLICK_TIME_BEFORE = 'last_click_time_before',
	CATEGORY = 'category',
	READ = 'read',
	TRAFFIK = 'traffic_type',
	TAG = 'tag',
	STATS = 'updating_statistics',
	OFFER_ID = 'offer_id',
	BRAND_ID = 'brand_id',
	SOURCE_ID = 'source_id',
	COUNTRY_ID = 'country_id',
	TYPE = 'type',
	REASON = 'reason',
	REPORT_TYPE = 'report_type',
	REPORT_GROUP_BY = 'report_group_by',
	OPEN = 'open',
	SEARCH_ID = 'search',
	ERROR_CODE = 'error_code',
	SUBID1 = 'subid1',
	SUBID2 = 'subid2',
	SUBID3 = 'subid3',
	PLATFORM_CODE = 'platform_code',
	LANDING_CODE = 'landing_code',
	CROSS_SELL = 'cross_sell',
	ONLY_CROSS_SELL = 'only_cross_sell',
	ONLY_DIRECT_SELL = 'only_direct_sell',
	ONLY_UNKNOW_SELL = 'only_unknown_sell',
	RECOMMENDED = 'recommended',
}

export enum EFilterOptions {
	ALL = 'all',
}
